import { useTheme } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { ActivityBasicInfoSection } from "web_myplann/Activities/Components/ActivityBasicInfoSection";
import { ActivityNotesSection } from "web_myplann/Activities/Components/ActivityNotesSection";
import { ActivityParticipantsSection } from "web_myplann/Activities/Components/ActivityParticipantsSection";
import { useActivityDetail } from "web_myplann/Activities/Hooks/useActivityDetail";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailLoader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailLoader";
import { ContactHeaderActions } from "web_myplann/Shared/Components/ContactHeaderActions";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { useNotFoundRedirect } from "web_myplann/Shared/Hooks/useNotFoundRedirect";
import { getBackFallbackRoute } from "web_myplann/Shared/Utils/backNavigation";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";

const R = Resources.Activity.Detail;

export const ActivityDetailV2Page = () => {
	const routeParams = useParams<{ id: string }>();
	const activityId = getTypedParam(routeParams, "id", Number) ?? null;
	const theme = useTheme();
	const { t } = useResource();
	const location = useLocation();

	const { event, notes, participantGroups, isLoading, isNotFound, contact } =
		useActivityDetail(activityId);
	useNotFoundRedirect({
		isNotFound,
		message: t(R.notFoundToast),
		defaultRoute: Routing.ActivitiesList.path(),
		invalidateQueryKeys: [ActivityKeys.lists(), ActivityKeys.events()],
	});

	if (activityId === null) return null;

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(R.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={getBackFallbackRoute(location.pathname)}
					replaceOnBack
					endComponent={<ContactHeaderActions contact={contact} />}
				/>
			}
		>
			{isLoading && <DetailLoader />}
			{!isLoading && event && (
				<>
					<ActivityBasicInfoSection event={event} />
					<ActivityParticipantsSection groups={participantGroups} />
					{notes.length > 0 && <ActivityNotesSection notes={notes} />}
				</>
			)}
		</MyPlannLayout>
	);
};
